import { Injectable } from '@angular/core';
import { BillDiscountType, BillMarkupType, MarkupBasedOn, ProviderDiscount, ProviderMarkup } from '../models/medical-bill';
import { ICategory } from '../models/procedure';

export interface BillMarkupRequest {
    markupType: BillMarkupType;
    markupBasedOn: MarkupBasedOn;
    categoryId?: number;
    amount: number;
    replaceExisting: boolean;
    extraDiscountSubsequentProcedures: boolean;
    subsequentProcedureDiscount: number;
}

export interface BillDiscountRequest {
    discountType: BillDiscountType;
    categoryId?: number;
    amount: number;
    replaceExisting: boolean;
    extraDiscountSubsequentProcedures: boolean;
    subsequentProcedureDiscount: number;
}

@Injectable()
export abstract class PracticeRatesService {
    abstract addPracticeMarkup(ein: string, request: BillMarkupRequest): Promise<void>;
    abstract addPracticeDiscount(ein: string, request: BillDiscountRequest): Promise<void>;
    abstract getCategories(): Promise<ICategory[]>;

    abstract getLocationMarkups(ein: string, locationId: number, npi: string): Promise<ProviderMarkup[]>;
    abstract getLocationDiscounts(ein: string, locationId: number, npi: string): Promise<ProviderDiscount[]>;
    abstract addLocationMarkup(ein: string, locationId: number, npi: string, request: BillMarkupRequest): Promise<ProviderMarkup>;
    abstract addLocationDiscount(ein: string, locationId: number, npi: string, request: BillDiscountRequest): Promise<ProviderDiscount>;
    abstract deleteLocationMarkup(ein: string, locationId: number, npi: string, markupId: number): Promise<void>;
    abstract deleteLocationDiscount(ein: string, locationId: number, npi: string, discountId: number): Promise<void>;
}
